import { CARDS, CARD_GUIDES, CARD_KINDS } from '../shared/cards';
import { CardArt } from './PartyArt';

export function CardCatalog() {
  return <div className="card-catalog"><p className="lead">카드는 각자 한 장, 사용 결정도 각자. 팀원의 손패는 서로 볼 수 있어요.</p><p className="catalog-rule">사용한 차례를 제외하고 우리 팀 차례가 두 번 끝나면 3장 중 새 카드 1장을 고릅니다. 밀치기·물귀신·우리 차례의 긴급탈출은 팀 차례당 합쳐서 1장입니다.</p>
    {CARD_KINDS.map(kind => <article key={kind} className="catalog-card"><CardArt card={kind} /><div><h3>{CARDS[kind].name}</h3><span className="catalog-timing">{CARDS[kind].timing}</span><p>{CARDS[kind].description}</p><p><b>사용법</b> {CARD_GUIDES[kind].how}</p><p className="card-example"><b>예시</b> {CARD_GUIDES[kind].example}</p><small>{CARD_GUIDES[kind].note}</small></div></article>)}
  </div>;
}
